/* eslint-disable react-hooks/exhaustive-deps */
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/modal/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/svg-icon/style.scss";
import "@ingka/accordion/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/carousel/style.scss";
import Modal, { Sheets, ModalHeader, ModalFooter, ModalBody } from "@ingka/modal";
import { OverflowCarousel } from "@ingka/carousel";
import Accordion, { AccordionItem } from "@ingka/accordion";
import Button from "../content/Button";
import { useEffect, useState } from "react";
import filterIcon from '@ingka/ssr-icon/paths/filters'
import { useTranslation } from "react-i18next";
import style from "../../assets/scss/components/global/filter.module.scss"
import cross from '@ingka/ssr-icon/paths/cross-small'
import { useDispatch, useSelector } from "react-redux";
import RadioGroup from "../form/RadioGroup";
import { updateFilterCategoryProductivity, updateFilterDepartment, updateFilterFlow, updateFilterHfb, updateFilterMonth, updateFilterMyActions, updateFilterPa, updateFilterPCD, updateFilterPeriod, updateFilterState, updateFilterStore, updateFlowSelected } from "../../store/globalSlice";
import { setCategoryProductivity, setPas, setPCDs } from "../../store/filtersSlice";
import Switch from "../form/Switch";
import { COWORKER } from "../../utils/roles";
import { getCategoryProductivity, getPas } from "../../services/mainServices";
import { TAB_KEYS } from "../../utils/dasboard-tab-keys";
import { getPCDOptions } from "../../services/flowServices";
import { getCurrentPCD } from "../../utils/get-current-pcd";

export default function Filter() {
  const[modalOpen, setModalOpen] = useState(false)
  const hfbs = useSelector((state) => state.filters.hfbs)
  const periods = useSelector((state) => state.filters.periods)
  const pcds = useSelector((state) => state.filters.pcds)
  const stores = useSelector((state) => state.filters.stores)
  const filters = useSelector((state) => state.global.filtersSelected)
  const week = useSelector((state) => state.global.beforeWeek)
  const pas = useSelector((state) => state.filters.pas)
  const flowSelected = useSelector((state) => state.global.flowSelected)
  const page = useSelector((state) => state.global.page)
  const myStore = useSelector((state) => state.global.myStore)
  const rol = useSelector((state) => state.global.rol)
  const hfbSelected = useSelector((state) => state.global.filtersSelected.hfb)
  const flowsRaw = useSelector((state) => state.flows)
  const [t] = useTranslation("global")
  const dispatch = useDispatch();
  const [paVisible, setPaVisible] = useState(false)
  const [hfbVisible, setHfbVisible] = useState(true)
  const [periodVisible, setPeriodVisible] = useState(true)
  const [storeVisible, setStoreVisible] = useState(true)
  const [pcdVisible, setPCDVisible] = useState(false)
  const [inActions, setInActions] = useState(false)
  const flows = [{id:0, name: "All"}, ...flowsRaw]
  const [productivityFiltersVisible, setProductivityFiltersVisible] = useState(false)
  const departments = useSelector((state) => state.filters.departments)
  const categories = useSelector((state) => state.filters.categoryProductivity)
  const months = useSelector((state) => state.global.monthOptions)
  const lastDateData = useSelector((state) => state.global.lastDateData)
  const dashboardTabSelected = useSelector(
    (state) => state.global.dashboardTabSelected
  )

  const [draftFilters, setDraftFilters] = useState({
    store: null,
    hfb: null,
    period: null,
    pcd: null,
    pa: null,
    myActions: true,
    state: "active",
    flow: {id: "0", name: "All"},
    department: null,
    categoryProductivity: null,
    month: null
  });

  useEffect(() => {
    if (modalOpen) {
      setDraftFilters({
        store: filters.store || null,
        hfb: filters.hfb || null,
        period: filters.period || null,
        pcd: filters.pcd || null,
        pa: filters.pa || null,
        myActions: filters.myActions ?? true,
        state: filters.state || "active",
        flow: filters.flow || {id: "0", name: "All"},
        department: filters.department || null,
        categoryProductivity: filters.categoryProductivity || null,
        month: filters.month || null
      });
      if (inActions) {
        setStoreVisible(!(filters.myActions ?? true));
      }
    }
  }, [modalOpen, filters, inActions]);

  const clearFilter = (type)=>{
    switch (type){
      case "hfb":
        dispatch(updateFilterHfb(null))
        break;
      case "period":
        dispatch(updateFilterPeriod(null))
        break;
      case "pa":
        dispatch(updateFilterPa(null))
        break;
      default:
        return false
    }
  }
  
  const changeHfb = (e)=>{
    const selectedHfb = {id:e.target.value, name:e.target.name};
    setDraftFilters(prev => ({ ...prev, hfb: selectedHfb }));
    getPas({hfb: selectedHfb.id}).then( response => {
      dispatch(setPas(response))
      setDraftFilters(prev => ({ ...prev, pa: response[0] }));
    })
  }

  const changePeriod = (e)=>{
    setDraftFilters(prev => ({ ...prev, period: {id:e.target.value, name:e.target.name} }))
  }

  const changePCD = (e)=>{
    setDraftFilters(prev => ({ ...prev, pcd: {id:e.target.value, name:e.target.name} }))
  }

  const changeStore = (e)=>{
    setDraftFilters(prev => ({ ...prev, store: {id:e.target.value, name:e.target.name} }))
  }

  const changePa = (e)=>{
    setDraftFilters(prev => ({ ...prev, pa: {id:e.target.value, name:e.target.name} }))
  }

  const changeFlow = (e)=>{
    setDraftFilters(prev => ({ ...prev, flow: {id:e.target.value, name:e.target.name} }))
  }

  const changeMyActions = (e)=>{
    setStoreVisible(!e.target.checked)
    setDraftFilters(prev => ({ ...prev, myActions: e.target.checked }))
  }

  const changeState = (e)=>{
    setDraftFilters(prev => ({ ...prev, state: e.target.value }))
  }

  const changeDepartment = (e)=>{
    const selectedDept = e.target.value;
    setDraftFilters(prev => ({ ...prev, department: selectedDept, categoryProductivity: null }));
    goToGetCategories(selectedDept)
  }

  const goToGetCategories = (department) => {
    getCategoryProductivity({department: department}).then( cats => {
      dispatch(setCategoryProductivity(cats))
      setDraftFilters(prev => ({ ...prev, categoryProductivity: cats[0] }));
    })
  }

  const changeCategory= (e)=>{
    setDraftFilters(prev => ({ ...prev, categoryProductivity: e.target.value }))
  }

  const changeMonth= (e)=>{
    setDraftFilters(prev => ({ ...prev, month: e.target.value }))
  }

  const handleApplyFilters = () => {
    if (draftFilters.hfb !== undefined) dispatch(updateFilterHfb(draftFilters.hfb))
    if (draftFilters.period !== undefined) dispatch(updateFilterPeriod(draftFilters.period))
    if (draftFilters.pa !== undefined) dispatch(updateFilterPa(draftFilters.pa))
    if (draftFilters.pcd !== undefined) dispatch(updateFilterPCD(draftFilters.pcd))
    if (draftFilters.store !== undefined) dispatch(updateFilterStore(draftFilters.store))
    if (draftFilters.flow !== undefined) dispatch(updateFilterFlow(draftFilters.flow))
    if (draftFilters.myActions !== undefined) dispatch(updateFilterMyActions(draftFilters.myActions))
    if (draftFilters.state !== undefined) dispatch(updateFilterState(draftFilters.state))
    if (draftFilters.department !== undefined) dispatch(updateFilterDepartment(draftFilters.department))
    if (draftFilters.categoryProductivity !== undefined) dispatch(updateFilterCategoryProductivity(draftFilters.categoryProductivity))
    if (draftFilters.month !== undefined) dispatch(updateFilterMonth(draftFilters.month))
    
    setModalOpen(false)
  }

  /*useEffect(()=>{
    const thePage = window.location.pathname
    if(thePage !== "/" || page !== "actions"){
      console.log(thePage)
      if(("flow2" === page  || "flow4" === page || "flow5" === page) && hfbSelected !== null){
        dispatch(updateFilterPa(null))
      }
    }
  },[hfbSelected, page])*/

  useEffect(()=>{
    if(("dashboard" === page || "flow2" === page || "flow3" === page || "flow4" === page || "flow5" === page || "flow8" === page) && hfbSelected){
      getPas({hfb:hfbSelected?.id}).then( response => {
        dispatch(setPas(response))
        dispatch(updateFilterPa(response[0]))
      })        
    }
  },[hfbSelected, page])

  useEffect(()=>{
    if(("dashboard" === page || "flow8" === page)){
      getPCDOptions().then( response => {
        dispatch(setPCDs(response))
        dispatch(updateFilterPCD(getCurrentPCD(response)))
      })
    }
  },[page])

  useEffect(()=>{
    switch (page){
      case "dashboard":
        dispatch(updateFlowSelected(null))
        setPaVisible(false)
        setHfbVisible(true)
        setStoreVisible(true)
        setInActions(false)
        setPeriodVisible(true)
        setPCDVisible(false)
        setProductivityFiltersVisible(false)
        break;
      case "new-action":
        setPaVisible(false)
        setStoreVisible(rol !== COWORKER ? true : false)
        setHfbVisible(flowSelected.id !== 7 ? true : false)
        dispatch(updateFilterStore(myStore))
        setPCDVisible(flowSelected.id === 8)
        setInActions(false)
        setPeriodVisible(true)
        setPeriodVisible(false)
        setProductivityFiltersVisible(false)
        break;
      case "actions":
        dispatch(updateFlowSelected(null))
        dispatch(updateFilterHfb(null))
        dispatch(updateFilterPa(null))
        dispatch(updateFilterMyActions(true))
        setHfbVisible(true)
        setPaVisible(false)
        setStoreVisible(false)
        setInActions(true)
        setPeriodVisible(false)
        setPCDVisible(false)
        setProductivityFiltersVisible(false)
        break;
      case "flow1":
        dispatch(updateFilterPa(null))
        setHfbVisible(true)
        setPaVisible(false)
        setStoreVisible(true)
        setInActions(false)
        setPCDVisible(false)
        setPeriodVisible(true)
        break;
      case "flow2": case "flow3": case "flow4": case "flow5":
        if(!filters.pa) dispatch(updateFilterPa(pas[0]))
        setHfbVisible(true)
        setPaVisible(true)
        setStoreVisible(true)
        setInActions(false)
        setPeriodVisible(true)
        setPCDVisible(false)
        break;
      case "flow7": 
        setPaVisible(false)
        setStoreVisible(true)
        setInActions(false)
        setPeriodVisible(false)
        setProductivityFiltersVisible(true)
        setHfbVisible(false)
        setPCDVisible(false)
        break;
      case "flow8":
        setPaVisible(true)
        setStoreVisible(true)
        setInActions(false)
        setPeriodVisible(false)
        setHfbVisible(true)
        setPCDVisible(true)
        break;
      default:
        break;
    }
  },[page])

  useEffect(() => {
    if(page !== "dashboard") return
    setPeriodVisible(dashboardTabSelected !== TAB_KEYS.LOGISTIC && dashboardTabSelected !== TAB_KEYS.PRODUCTIVITY)
  }, [dashboardTabSelected, page])

  return (
    <>
    {filters && week !== undefined && hfbs && periods &&
      <>
      <div className={style.containerFilters}>
        <div className={style.filterButtons}>
          <OverflowCarousel
          controlBtnType="primary"
          id="demo">
            <Button 
              onClick={() => setModalOpen(!modalOpen)}
              type="tertiary"
              iconOnly
              ssrIcon={filterIcon}
              size="small"
            />
            <Button 
              type="tertiary"
              text={filters.myActions && inActions ? t('actions.myActions') : filters.store.id}
              size="small"
              className={style.filterButton}
              onClick={()=>setModalOpen(!modalOpen)}
            />
            
            {filters.period && periodVisible &&
              <Button 
              type="tertiary"
              text={`${filters.period.id} ${filters.period.id ==="WEEK" ? week : ''}`}
              size="small"
              className={style.filterButton}
              onClick={()=>setModalOpen(!modalOpen)}
            />
            }
            {inActions &&
              <Button 
              type="tertiary"
              text={filters.state === "all" ? t('global.state')+": "+t('actions.'+filters.state) : t('actions.'+filters.state)}
              size="small"
              className={style.filterButton}
              onClick={()=>setModalOpen(!modalOpen)}
            />
            }
            {inActions &&
              <Button 
              type="tertiary"
              text={`${t('actions.flow')}: ${filters.flow.id === "0" ? t('global.all') : filters.flow.id}`}
              size="small"
              className={style.filterButton}
              onClick={()=>setModalOpen(!modalOpen)}
            />
            }
            {filters.hfb && page !== "flow7" && flowSelected?.id !== 7 &&
              <Button 
              onClick={()=>{
                if(flowSelected === null){
                  clearFilter("hfb")
                } else{
                  setModalOpen(!modalOpen)
                }
              }}
              type="tertiary"
              text={`HFB ${filters.hfb.id}`}
              ssrIcon={flowSelected === null ? cross : null}
              size="small"
              className={style.filterButton}
            />
            }
            {filters.pa && page !== "flow1" && page !== "dashboard" && page !== "flow7" &&
              <Button 
              onClick={()=>{
                if(flowSelected === null){
                  clearFilter("pa")
                } else{
                  setModalOpen(!modalOpen)
                }
              }}
              type="tertiary"
              text={`PA ${filters.pa.id}`}
              ssrIcon={flowSelected === null ? cross : null}
              size="small"
              className={style.filterButton}
            />
            }
            {filters.pcd && pcdVisible && 
              <Button 
              type="tertiary"
              text={filters.pcd.name}
              size="small"
              className={style.filterButton}
              onClick={()=>setModalOpen(!modalOpen)}
              />
            }
            {page === "flow7" && page !== "dashboard" &&
              <>
                <Button 
                  onClick={()=>{
                    setModalOpen(!modalOpen)
                  }}
                  type="tertiary"
                  text={t(`months.${filters.month}`)}
                  size="small"
                  className={style.filterButton}
                />
                <Button 
                  onClick={()=>{
                    setModalOpen(!modalOpen)
                  }}
                  type="tertiary"
                  text={filters.department}
                  size="small"
                  className={style.filterButton}
                />
                <Button 
                  onClick={()=>{
                    setModalOpen(!modalOpen)
                  }}
                  type="tertiary"
                  text={filters.categoryProductivity}
                  size="small"
                  className={style.filterButton}
                />
              </>
            }
          </OverflowCarousel>
          <hr/>
        </div>
      </div>

      <Modal
        visible={modalOpen}
        focusLockProps={{
          disabled: false
        }}
        handleCloseBtn={()=> setModalOpen(!modalOpen)}
        >
        <Sheets
          aria-label="Accessibility header for a modal"
          header={<ModalHeader className={style.modal_header} title={t("components.filter.title")}/>}
          footer={
            <ModalFooter className="d-flex justify-content-end gap-2">
              <Button 
                onClick={() => setModalOpen(false)}
                type="secondary"
                text={t("global.cancel")}
                size="small"
              />
              <Button 
                onClick={handleApplyFilters}
                type="primary"
                text={t("global.apply")}
                size="small"
              />
            </ModalFooter>
          }
        >
          <ModalBody>
            {/* SWITCH FOR ACTIONS */}
            {inActions &&
            <>
              <Switch props={{
                className:"mb-2",
                id: "myActions",
                name: "My_actions",
                label: t("actions.myActions"),
                checked: draftFilters.myActions,
                onChange: changeMyActions
              }}
              />
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.state && t('actions.'+draftFilters.state) }
                  id="flows"
                  title={t('global.state')}
                > 
                  <RadioGroup
                  radio={{
                    onChange: changeState,
                    list: [
                      {
                        id: 'all',
                        label: t('actions.all'),
                        value: 'all',
                        name: 'all',
                        checked: draftFilters.state === "all",
                      },
                      {
                        id: 'active',
                        label: t('actions.active'),
                        value: 'active',
                        name: 'active',
                        checked: draftFilters.state === "active",
                      },
                      {
                        id: 'pending',
                        label: t('actions.pendingState'),
                        value: 'pending',
                        name: 'pending',
                        checked: draftFilters.state === "pending",
                      },
                      {
                        id: 'finalize',
                        label: t('actions.finalize'),
                        value: 'finalize',
                        name: 'finalize',
                        checked: draftFilters.state === "finalize",
                      },
                    ]
                  }}/>
                </AccordionItem>
              </Accordion>
            </>
            }

            {/* FLOWS */}
            {inActions &&
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.flow && `${draftFilters.flow.id} - ${draftFilters.flow.id === 0 ? t('global.all') : draftFilters.flow.name}`}
                  id="flows"
                  title={t('actions.flow')}
                > 
                  <RadioGroup
                  radio={{
                    list:
                      flows?.map(flow=>(
                        {disabled: false,
                        id: flow.id,
                        label: `${flow.id} - ${flow.id === "0" ? t('global.all') : flow.name}`,
                        name: flow.id === "0" ? t('global.all') : flow.name,
                        value: flow.id,
                        checked: draftFilters.flow && parseInt(flow.id) === parseInt(draftFilters.flow.id),
                        onChange: changeFlow
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>
            }
            
            {/* STORES */}
            {storeVisible && 
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.store && `${draftFilters.store.id} - ${draftFilters.store.name}`}
                  id="stores"
                  title="Store"
                > 
                  <RadioGroup
                  radio={{
                    list:
                      stores?.map(store=>(
                        {disabled: false,
                        id: store.id,
                        label: `${store.id} - ${store.name}`,
                        name: store.name,
                        value: store.id,
                        checked: draftFilters.store && store.id === draftFilters.store.id,
                        onChange: changeStore
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>
            }

            {/* PERIODS */}
            {periodVisible &&
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.period && `${draftFilters.period.id} ${draftFilters.period.id === "WEEK" ? " - "+week : ""}`}
                  id="period"
                  title="Period"
                > 
                  <RadioGroup
                  radio={{
                    list:
                      periods?.map(period=>(
                        {disabled: false,
                        id: period.id,
                        name: period.name,
                        label: `${period.id} - ${period.name}`,
                        value: period.id,
                        checked: draftFilters.period && period.id === draftFilters.period.id,
                        onChange: changePeriod
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>
            }
            
            {/* HFB */}
            {!productivityFiltersVisible && hfbVisible &&
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.hfb && `${draftFilters.hfb.id} - ${draftFilters.hfb.name}`}
                  id="hfb"
                  title="HFB"
                > 
                  <RadioGroup
                  radio={{
                    list:
                      hfbs?.map(hfb=>(
                        {disabled: false,
                        id: hfb.id,
                        label: `${hfb.id} - ${hfb.name}`,
                        name:hfb.name,
                        value: hfb.id,
                        checked: draftFilters.hfb && hfb.id === draftFilters.hfb.id,
                        onChange: changeHfb
                      }
                      )),
                  }}/>
                </AccordionItem>
              </Accordion>
            }
            
            
            {/* PA */}
            {paVisible && hfbSelected !== null &&
            <Accordion collapsible={false}>
              <AccordionItem
                caption={draftFilters.pa && `${draftFilters.pa.id} - ${draftFilters.pa.name}`}
                id="pa"
                title="PA"
              > 
                <RadioGroup
                radio={{
                  list:
                    pas?.map(pa=>(
                      {disabled: false,
                      id: pa.id,
                      label: `${pa.id} - ${pa.name}`,
                      name: pa.name,
                      value: pa.id,
                      checked: draftFilters.pa && pa.id === draftFilters.pa.id,
                      onChange: changePa
                    }
                    ))
                }}/>
              </AccordionItem>
            </Accordion>
            }

             {/* PCDS */}
             {pcdVisible &&
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.pcd && `${draftFilters.pcd.name}`}
                  id="pcd"
                  title="PCD"
                > 
                  <RadioGroup
                  radio={{
                    list:
                      pcds?.map(pcd=>(
                        {disabled: false,
                        id: pcd.id,
                        name: pcd.name,
                        label: pcd.name,
                        value: pcd.id,
                        checked: draftFilters.pcd && pcd.id === draftFilters.pcd.id,
                        onChange: changePCD
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>
            }

            {/* PRODUCTIVITY */}
            {productivityFiltersVisible &&
            <>
              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.month && t(`months.${draftFilters.month}`)}
                  id="month"
                  title={`${t('components.filter.month')} ${lastDateData.year}`}
                > 
                  <RadioGroup
                  radio={{
                    list:
                      months?.map(month=>(
                        {disabled: false,
                        id: month,
                        label: t(`months.${month}`),
                        name: t(`months.${month}`),
                        value: month,
                        checked: draftFilters.month && month === draftFilters.month,
                        onChange: changeMonth
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>

              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.department && `${draftFilters.department}`}
                  id="department"
                  title={t('global.department')}
                > 
                  <RadioGroup
                  radio={{
                    list:
                      departments?.map(dep=>(
                        {disabled: false,
                        id: dep,
                        label: `${dep}`,
                        name: dep,
                        value: dep,
                        checked: draftFilters.department && dep === draftFilters.department,
                        onChange: changeDepartment
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>

              <Accordion collapsible={false}>
                <AccordionItem
                  caption={draftFilters.categoryProductivity && `${draftFilters.categoryProductivity}`}
                  id="category"
                  title={t('components.filter.productivityCategory')}
                > 
                  <RadioGroup
                  radio={{
                    list:
                      categories?.map(cat=>(
                        {disabled: false,
                        id: cat,
                        label: `${cat}`,
                        name: cat,
                        value: cat,
                        checked: draftFilters.categoryProductivity && cat === draftFilters.categoryProductivity,
                        onChange: changeCategory
                      }
                      ))
                  }}/>
                </AccordionItem>
              </Accordion>
            </>
            }
          </ModalBody>
        </Sheets>
      </Modal>
      </>
      }
    </>
  )
}